module.exports = __webpack_public_path__ + "static/media/empty-questions.2e87d810.svg";